/* Comforts Kids buy box live state (03-07): total, nudge, delivery ETA, sold-out status and
   every WhatsApp order link. Figures are display-only estimates (D-18): Shopify's automatic
   discount and shipping rate are authoritative at checkout. */
(function () {
  'use strict';
  if (window.__ckBuyLoaded) return;
  window.__ckBuyLoaded = true;

  var DAY_MS = 86400000;
  var TZ = 'Asia/Karachi';

  function formatMoney(cents) {
    if (window.CK && typeof window.CK.money === 'function') return window.CK.money(cents);
    return 'Rs ' + Math.round(cents / 100).toLocaleString('en-US');
  }

  function setText(el, text) {
    if (el && el.textContent !== text) el.textContent = text;
  }

  function setHidden(el, hidden) {
    if (el && el.hidden !== hidden) el.hidden = hidden;
  }

  function karachiLabel(date) {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: TZ,
      weekday: 'short',
      day: 'numeric',
      month: 'short',
    }).formatToParts(date);
    var p = {};
    parts.forEach(function (part) {
      p[part.type] = part.value;
    });
    return p.weekday + ' ' + p.day + ' ' + p.month;
  }

  function karachiIso(date) {
    return new Intl.DateTimeFormat('en-CA', {
      timeZone: TZ,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).format(date);
  }

  function timeNode(date) {
    var t = document.createElement('time');
    t.setAttribute('datetime', karachiIso(date));
    t.textContent = karachiLabel(date);
    return t;
  }

  function renderEta(el, min, max) {
    if (!el || !isFinite(min) || !isFinite(max)) return;
    var now = Date.now();
    var from = new Date(now + min * DAY_MS);
    var to = new Date(now + max * DAY_MS);
    var key = karachiIso(from) + '|' + karachiIso(to);
    if (el.ckEtaKey === key) return;
    el.ckEtaKey = key;
    while (el.firstChild) el.removeChild(el.firstChild);
    el.appendChild(document.createTextNode('Order today and it arrives between '));
    el.appendChild(timeNode(from));
    el.appendChild(document.createTextNode(' and '));
    el.appendChild(timeNode(to));
    el.appendChild(document.createTextNode('.'));
  }

  function init(box) {
    if (box.__ckBuy) return;
    box.__ckBuy = true;
    var info = box.closest('product-info') || document;
    var sectionId = box.getAttribute('data-section');
    var productUrl = box.getAttribute('data-product-url') || '';
    var siblings = Number(box.getAttribute('data-siblings-cents')) || 0;
    var textFee = box.getAttribute('data-text-fee') || '';
    var textFree = box.getAttribute('data-text-free') || 'Free delivery';
    var daysMin = Number(box.getAttribute('data-days-min'));
    var daysMax = Number(box.getAttribute('data-days-max'));
    var stored = null;

    var elTotal = box.querySelector('[data-ck-total]');
    var elDelivery = box.querySelector('[data-ck-delivery]');
    var elNudge = box.querySelector('[data-ck-nudge]');
    var elMakeTwo = box.querySelector('[data-ck-make-two]');
    var elApplied = box.querySelector('[data-ck-nudge-applied]');
    var elEta = box.querySelector('[data-ck-eta]');
    var elSold = box.querySelector('[data-ck-soldout]');

    function readVariant() {
      if (stored) return stored;
      var el = info.querySelector('variant-selects [data-selected-variant]');
      if (!el) return null;
      try {
        return JSON.parse(el.textContent);
      } catch (e) {
        return null;
      }
    }

    /* The product form is novalidate, so a typed quantity above the cap (max, 10 by default) would
       still be sent. Pull it back to the cap as soon as the field changes (blur, Go, steppers). */
    function clampQty(input) {
      var max = parseInt(input.getAttribute('max'), 10);
      var value = parseInt(input.value, 10);
      if (max > 0 && value > max) input.value = String(max);
    }

    function readQty() {
      var input = info.querySelector('.quantity__input');
      var q = input ? parseInt(input.value, 10) : 1;
      return q > 0 ? q : 1;
    }

    function render() {
      var variant = readVariant();
      var qty = readQty();
      var two = qty >= 2;

      if (variant && isFinite(Number(variant.price))) {
        var total = Number(variant.price) * qty - (two ? siblings : 0);
        setText(elTotal, formatMoney(Math.max(total, 0)));
      }
      setText(elDelivery, two ? textFree : textFee);

      setHidden(elNudge, two);
      setHidden(elMakeTwo, two);
      setHidden(elApplied, !two);

      setText(elSold, variant && variant.available === false ? 'Sold out. Choose another design.' : '');
      renderEta(elEta, daysMin, daysMax);

      if (variant) {
        var name = variant.option1 || variant.title || '';
        var url = window.location.origin + productUrl + '?variant=' + variant.id;
        var message = 'Hi Comforts Kids, I want to order: Design: ' + name + ', Quantity: ' + qty + '. Link: ' + url;
        var links = document.querySelectorAll('a[data-ck-wa]');
        for (var i = 0; i < links.length; i++) {
          /* the cart drawer's WhatsApp link carries its own cart message (03-14) */
          if (links[i].closest('cart-drawer')) continue;
          var href = window.CK && window.CK.waHref ? window.CK.waHref(links[i].getAttribute('data-ck-wa-number'), message) : null;
          if (href && links[i].getAttribute('href') !== href) links[i].setAttribute('href', href);
        }
      }
    }

    var unsubscribe = null;
    if (window.CK && typeof window.CK.onVariantChange === 'function') {
      unsubscribe = window.CK.onVariantChange(function (payload) {
        if (!box.isConnected) {
          // the theme editor re-rendered this section: the new box has its own subscription
          if (typeof unsubscribe === 'function') unsubscribe();
          return;
        }
        var data = payload && payload.data;
        if (!data || data.sectionId !== sectionId || !data.variant) return;
        stored = data.variant;
        render();
      });
    }

    info.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('.quantity__input')) {
        clampQty(e.target);
        render();
      }
    });
    info.addEventListener('input', function (e) {
      if (e.target && e.target.matches && e.target.matches('.quantity__input')) render();
    });
    /* Order now is the form's first submit button, so Enter (or "Go" on the Android number keypad) in
       the quantity field would press it and jump to checkout. Close the keypad instead (blur = change). */
    info.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || !e.target || !e.target.matches || !e.target.matches('.quantity__input')) return;
      e.preventDefault();
      e.target.blur();
    });

    if (elMakeTwo) {
      elMakeTwo.addEventListener('click', function () {
        var input = info.querySelector('.quantity__input');
        if (!input) return;
        var max = parseInt(input.getAttribute('max'), 10);
        input.value = max > 0 ? Math.min(2, max) : 2;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        render();
        if (elApplied && !elApplied.hidden) elApplied.focus();
      });
    }

    render();
  }

  function initWithin(scope) {
    var boxes = scope && scope.querySelectorAll ? scope.querySelectorAll('[data-ck-buy-box]') : [];
    for (var i = 0; i < boxes.length; i++) init(boxes[i]);
  }

  function start() {
    initWithin(document);
  }

  /* Theme editor: a section the owner edits is re-rendered with a new, unwired buy box */
  document.addEventListener('shopify:section:load', function (event) {
    initWithin(event.target);
  });

  /* Deferred scripts run while readyState is "interactive", before DOMContentLoaded; waiting for
     that event guarantees ck-core.js (CK) and pubsub.js are ready. */
  if (document.readyState === 'complete') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
